import {type IconDefinition} from '@fortawesome/fontawesome-svg-core'
export default {
    '9': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-fa9" */
        '@fortawesome/free-solid-svg-icons/fa9'
    ),
    'anchor': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faAnchor" */
        '@fortawesome/free-solid-svg-icons/faAnchor'
    ),
    'anchor-circle-check': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faAnchorCircleCheck" */
        '@fortawesome/free-solid-svg-icons/faAnchorCircleCheck'
    ),
    'anchor-circle-exclamation': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faAnchorCircleExclamation" */
        '@fortawesome/free-solid-svg-icons/faAnchorCircleExclamation'
    ),
    'arrow-alt-circle-right': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCircleRight" */
        '@fortawesome/free-solid-svg-icons/faCircleRight'
    ),
    'arrow-down-wide-short': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSortAmountDown" */
        '@fortawesome/free-solid-svg-icons/faSortAmountDown'
    ),
    'arrow-right-to-bracket': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSignIn" */
        '@fortawesome/free-solid-svg-icons/faSignIn'
    ),
    'arrow-up-wide-short': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSortAmountUp" */
        '@fortawesome/free-solid-svg-icons/faSortAmountUp'
    ),
    'arrow-up-z-a': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSortAlphaUpAlt" */
        '@fortawesome/free-solid-svg-icons/faSortAlphaUpAlt'
    ),
    'arrows-h': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faArrowsLeftRight" */
        '@fortawesome/free-solid-svg-icons/faArrowsLeftRight'
    ),
    'assistive-listening-systems': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faEarListen" */
        '@fortawesome/free-solid-svg-icons/faEarListen'
    ),
    'audio-description': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faAudioDescription" */
        '@fortawesome/free-solid-svg-icons/faAudioDescription'
    ),
    'ban': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCancel" */
        '@fortawesome/free-solid-svg-icons/faCancel'
    ),
    'battery-full': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBatteryFull" */
        '@fortawesome/free-solid-svg-icons/faBatteryFull'
    ),
    'battery-half': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBatteryHalf" */
        '@fortawesome/free-solid-svg-icons/faBatteryHalf'
    ),
    'beer-mug-empty': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBeerMugEmpty" */
        '@fortawesome/free-solid-svg-icons/faBeerMugEmpty'
    ),
    'biohazard': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBiohazard" */
        '@fortawesome/free-solid-svg-icons/faBiohazard'
    ),
    'border-all': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBorderAll" */
        '@fortawesome/free-solid-svg-icons/faBorderAll'
    ),
    'braille': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBraille" */
        '@fortawesome/free-solid-svg-icons/faBraille'
    ),
    'building-ngo': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBuildingNgo" */
        '@fortawesome/free-solid-svg-icons/faBuildingNgo'
    ),
    'bullseye': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBullseye" */
        '@fortawesome/free-solid-svg-icons/faBullseye'
    ),
    'c': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faC" */
        '@fortawesome/free-solid-svg-icons/faC'
    ),
    'calculator': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCalculator" */
        '@fortawesome/free-solid-svg-icons/faCalculator'
    ),
    'car-battery': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCarBattery" */
        '@fortawesome/free-solid-svg-icons/faCarBattery'
    ),
    'car-side': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCarSide" */
        '@fortawesome/free-solid-svg-icons/faCarSide'
    ),
    'caret-left': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCaretLeft" */
        '@fortawesome/free-solid-svg-icons/faCaretLeft'
    ),
    'cart-flatbed': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faDollyFlatbed" */
        '@fortawesome/free-solid-svg-icons/faDollyFlatbed'
    ),
    'chart-area': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faChartArea" */
        '@fortawesome/free-solid-svg-icons/faChartArea'
    ),
    'chart-diagram': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faChartDiagram" */
        '@fortawesome/free-solid-svg-icons/faChartDiagram'
    ),
    'circle-right': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCircleRight" */
        '@fortawesome/free-solid-svg-icons/faCircleRight'
    ),
    'city': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCity" */
        '@fortawesome/free-solid-svg-icons/faCity'
    ),
    'cloud-upload': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCloudUploadAlt" */
        '@fortawesome/free-solid-svg-icons/faCloudUploadAlt'
    ),
    'crown': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCrown" */
        '@fortawesome/free-solid-svg-icons/faCrown'
    ),
    'cruzeiro-sign': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCruzeiroSign" */
        '@fortawesome/free-solid-svg-icons/faCruzeiroSign'
    ),
    'dumbbell': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faDumbbell" */
        '@fortawesome/free-solid-svg-icons/faDumbbell'
    ),
    'eye-slash': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faEyeSlash" */
        '@fortawesome/free-solid-svg-icons/faEyeSlash'
    ),
    'face-dizzy': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faFaceDizzy" */
        '@fortawesome/free-solid-svg-icons/faFaceDizzy'
    ),
    'face-grin-wide': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faGrinAlt" */
        '@fortawesome/free-solid-svg-icons/faGrinAlt'
    ),
    'feather-pointed': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faFeatherPointed" */
        '@fortawesome/free-solid-svg-icons/faFeatherPointed'
    ),
    'ferry': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faFerry" */
        '@fortawesome/free-solid-svg-icons/faFerry'
    ),
    'file-fragment': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faFileFragment" */
        '@fortawesome/free-solid-svg-icons/faFileFragment'
    ),
    'file-invoice-dollar': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faFileInvoiceDollar" */
        '@fortawesome/free-solid-svg-icons/faFileInvoiceDollar'
    ),
    'file-medical': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faFileMedical" */
        '@fortawesome/free-solid-svg-icons/faFileMedical'
    ),
    'font': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faFont" */
        '@fortawesome/free-solid-svg-icons/faFont'
    ),
    'font-awesome-flag': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faFontAwesomeLogoFull" */
        '@fortawesome/free-solid-svg-icons/faFontAwesomeLogoFull'
    ),
    'franc-sign': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faFrancSign" */
        '@fortawesome/free-solid-svg-icons/faFrancSign'
    ),
    'genderless': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faGenderless" */
        '@fortawesome/free-solid-svg-icons/faGenderless'
    ),
    'glass-water': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faGlassWater" */
        '@fortawesome/free-solid-svg-icons/faGlassWater'
    ),
    'guitar': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faGuitar" */
        '@fortawesome/free-solid-svg-icons/faGuitar'
    ),
    'hand-holding-medical': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHandHoldingMedical" */
        '@fortawesome/free-solid-svg-icons/faHandHoldingMedical'
    ),
    'hand-lizard': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHandLizard" */
        '@fortawesome/free-solid-svg-icons/faHandLizard'
    ),
    'head-side-mask': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHeadSideMask" */
        '@fortawesome/free-solid-svg-icons/faHeadSideMask'
    ),
    'helmet-un': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHelmetUn" */
        '@fortawesome/free-solid-svg-icons/faHelmetUn'
    ),
    'hourglass-3': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHourglassEnd" */
        '@fortawesome/free-solid-svg-icons/faHourglassEnd'
    ),
    'house-medical-circle-exclamation': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHouseMedicalCircleExclamation" */
        '@fortawesome/free-solid-svg-icons/faHouseMedicalCircleExclamation'
    ),
    'house-medical-circle-xmark': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHouseMedicalCircleXmark" */
        '@fortawesome/free-solid-svg-icons/faHouseMedicalCircleXmark'
    ),
    'kiss': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faKiss" */
        '@fortawesome/free-solid-svg-icons/faKiss'
    ),
    'kiss-beam': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faKissBeam" */
        '@fortawesome/free-solid-svg-icons/faKissBeam'
    ),
    'lightbulb': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faLightbulb" */
        '@fortawesome/free-solid-svg-icons/faLightbulb'
    ),
    'litecoin-sign': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faLitecoinSign" */
        '@fortawesome/free-solid-svg-icons/faLitecoinSign'
    ),
    'magnifying-glass-dollar': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSearchDollar" */
        '@fortawesome/free-solid-svg-icons/faSearchDollar'
    ),
    'magnifying-glass-location': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSearchLocation" */
        '@fortawesome/free-solid-svg-icons/faSearchLocation'
    ),
    'money-bill-wave': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faMoneyBillWave" */
        '@fortawesome/free-solid-svg-icons/faMoneyBillWave'
    ),
    'money-check-alt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faMoneyCheckDollar" */
        '@fortawesome/free-solid-svg-icons/faMoneyCheckDollar'
    ),
    'mortar-board': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faMortarBoard" */
        '@fortawesome/free-solid-svg-icons/faMortarBoard'
    ),
    'mouse': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faMouse" */
        '@fortawesome/free-solid-svg-icons/faMouse'
    ),
    'oil-can': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faOilCan" */
        '@fortawesome/free-solid-svg-icons/faOilCan'
    ),
    'pencil-alt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPencilAlt" */
        '@fortawesome/free-solid-svg-icons/faPencilAlt'
    ),
    'person-digging': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPersonDigging" */
        '@fortawesome/free-solid-svg-icons/faPersonDigging'
    ),
    'person-swimming': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSwimmer" */
        '@fortawesome/free-solid-svg-icons/faSwimmer'
    ),
    'phone-square': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSquarePhone" */
        '@fortawesome/free-solid-svg-icons/faSquarePhone'
    ),
    'prescription-bottle-alt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPrescriptionBottleMedical" */
        '@fortawesome/free-solid-svg-icons/faPrescriptionBottleMedical'
    ),
    'qrcode': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faQrcode" */
        '@fortawesome/free-solid-svg-icons/faQrcode'
    ),
    'r': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faR" */
        '@fortawesome/free-solid-svg-icons/faR'
    ),
    'save': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSave" */
        '@fortawesome/free-solid-svg-icons/faSave'
    ),
    'school-circle-check': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSchoolCircleCheck" */
        '@fortawesome/free-solid-svg-icons/faSchoolCircleCheck'
    ),
    'school-circle-xmark': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSchoolCircleXmark" */
        '@fortawesome/free-solid-svg-icons/faSchoolCircleXmark'
    ),
    'sign-in': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSignIn" */
        '@fortawesome/free-solid-svg-icons/faSignIn'
    ),
    'skiing-nordic': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSkiingNordic" */
        '@fortawesome/free-solid-svg-icons/faSkiingNordic'
    ),
    'smile-beam': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSmileBeam" */
        '@fortawesome/free-solid-svg-icons/faSmileBeam'
    ),
    'sort-amount-up': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSortAmountUp" */
        '@fortawesome/free-solid-svg-icons/faSortAmountUp'
    ),
    'spoon': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faUtensilSpoon" */
        '@fortawesome/free-solid-svg-icons/faUtensilSpoon'
    ),
    'square-binary': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSquareBinary" */
        '@fortawesome/free-solid-svg-icons/faSquareBinary'
    ),
    'square-minus': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSquareMinus" */
        '@fortawesome/free-solid-svg-icons/faSquareMinus'
    ),
    'square-root-variable': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSquareRootVariable" */
        '@fortawesome/free-solid-svg-icons/faSquareRootVariable'
    ),
    'staff-snake': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faStaffSnake" */
        '@fortawesome/free-solid-svg-icons/faStaffSnake'
    ),
    'star-of-david': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faStarOfDavid" */
        '@fortawesome/free-solid-svg-icons/faStarOfDavid'
    ),
    'table-cells': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTh" */
        '@fortawesome/free-solid-svg-icons/faTh'
    ),
    'table-tennis': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTableTennisPaddleBall" */
        '@fortawesome/free-solid-svg-icons/faTableTennisPaddleBall'
    ),
    'tachometer-alt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTachometerAltFast" */
        '@fortawesome/free-solid-svg-icons/faTachometerAltFast'
    ),
    'teeth-open': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTeethOpen" */
        '@fortawesome/free-solid-svg-icons/faTeethOpen'
    ),
    'thumbs-up': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faThumbsUp" */
        '@fortawesome/free-solid-svg-icons/faThumbsUp'
    ),
    'thunderstorm': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faThunderstorm" */
        '@fortawesome/free-solid-svg-icons/faThunderstorm'
    ),
    'toilet': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faToilet" */
        '@fortawesome/free-solid-svg-icons/faToilet'
    ),
    'tools': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTools" */
        '@fortawesome/free-solid-svg-icons/faTools'
    ),
    'train-tram': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTrainTram" */
        '@fortawesome/free-solid-svg-icons/faTrainTram'
    ),
    'trash-alt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTrashCan" */
        '@fortawesome/free-solid-svg-icons/faTrashCan'
    ),
    'truck-plane': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTruckPlane" */
        '@fortawesome/free-solid-svg-icons/faTruckPlane'
    ),
    'turn-up': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTurnUp" */
        '@fortawesome/free-solid-svg-icons/faTurnUp'
    ),
    'unlock': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faUnlock" */
        '@fortawesome/free-solid-svg-icons/faUnlock'
    ),
    'user-alt-slash': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faUserLargeSlash" */
        '@fortawesome/free-solid-svg-icons/faUserLargeSlash'
    ),
    'user-tie': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faUserTie" */
        '@fortawesome/free-solid-svg-icons/faUserTie'
    ),
    'users-cog': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faUsersGear" */
        '@fortawesome/free-solid-svg-icons/faUsersGear'
    ),
    'utensil-spoon': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faUtensilSpoon" */
        '@fortawesome/free-solid-svg-icons/faUtensilSpoon'
    ),
    'vial-virus': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faVialVirus" */
        '@fortawesome/free-solid-svg-icons/faVialVirus'
    ),
    'video': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faVideoCamera" */
        '@fortawesome/free-solid-svg-icons/faVideoCamera'
    ),
    'wallet': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faWallet" */
        '@fortawesome/free-solid-svg-icons/faWallet'
    ),
    'wine-glass': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faWineGlass" */
        '@fortawesome/free-solid-svg-icons/faWineGlass'
    ),
    'y': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faY" */
        '@fortawesome/free-solid-svg-icons/faY'
    ),
} as Record<string, ()=>Promise<{ definition: IconDefinition }>>